import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const BlackStyledButton = styled(Button)({
    color: 'black'
});